export const colorList = [
  ['#FEC107', '#F1C40F', '#FFEB3C', '#CDDC39', '#8BC24A', '#2DCC70', '#4CB050'],
  ['#27AE61', '#006B61', '#16A086', '#1BBC9B', '#00BCD5', '#03A9F5', '#2196F3'],
  ['#3598DB', '#297FB8', '#3F51B5', '#673BB7', '#9C28B1', '#8C45AD', '#9A59B5'],
]

export const defaultColor = colorList[0][0]

export const HEART_COLOR = '#EC6C73'
export const SCRAP_COLOR = '#FFCF55'
